import React from 'react';

import { useTheme } from '@adsk/alloy-react-styles';
import { StylableComponent } from '@adsk/alloy-react-theme';

import { useTranslation } from '../../i18n';

const Placeholder = ({
  children,
  style,
  ...props
}: StylableComponent<HTMLDivElement>) => {
  const { t } = useTranslation();
  const { tokens } = useTheme();
  const placeholderTokens = tokens?.component.dropdown?.control?.placeholder;
  const placeholder = children || t('SELECT');

  return (
    <div
      dir="auto"
      css={[
        {
          pointerEvents: 'none',
          userSelect: 'none',
          flex: 1,
        },
        placeholderTokens?._,
        style,
      ]}
      {...props}
    >
      {placeholder}
    </div>
  );
};

export default Placeholder;
